import { render, staticRenderFns } from "./UnionMemberForm.vue?vue&type=template&id=c61f7a54&"
import script from "./UnionMemberForm.vue?vue&type=script&lang=js&"
export * from "./UnionMemberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports